<div class="schematic-overlay">
 <div class="schematic-modal">
    <div class="schematic-canvas">
      <lib-ac-line-schematic [acLineId]="acLineId"></lib-ac-line-schematic>
    </div>

    <div class="floating-actions">
      <button class="cy-btn cy-btn-close" (click)="onClose()">
        Close
      </button>
    </div>

    <lib-schematic-legend class="schematic-legend" [isAcLine]="true"></lib-schematic-legend>
  </div>
</div>